import React, { useEffect } from "react";

const Step = ({ currentStep, setCurrentFormStep, context }) => {
  const onStepClick = (stepToMove) => {
    setCurrentFormStep(stepToMove);
  };
  return (
    <div className="row bs-wizard" style={{ borderBottom: 0 }}>
      <div
        className={
          currentStep === 1
            ? "col-3 bs-wizard-step "
            : "col-3 bs-wizard-step complete"
        }
      >
        <div className="bs-wizard-stepnum">
          {context.t("STD-Employer-Statement.form.Step")} 1
        </div>
        <div className="progress">
          <div className="progress-bar"></div>
        </div>
        <a
          onClick={() => {
            onStepClick(1);
          }}
          className="bs-wizard-dot"
        ></a>
      </div>
      <div
        className={
          currentStep < 2
            ? "col-3 bs-wizard-step disabled"
            : currentStep > 2 ? "col-3 bs-wizard-step complete" : "col-3 bs-wizard-step"
        }
      >
        <div className="bs-wizard-stepnum">
          {context.t("STD-Employer-Statement.form.Step")} 2
        </div>
        <div className="progress">
          <div className="progress-bar"></div>
        </div>
        <a
          onClick={() => {
            onStepClick(2);
          }}
          className="bs-wizard-dot"
        ></a>
      </div>
      <div
        className={
          currentStep < 3
            ? "col-3 bs-wizard-step disabled "
            : currentStep > 3 ? "col-3 bs-wizard-step complete" : "col-3 bs-wizard-step"
        }
      >
        <div className="bs-wizard-stepnum">
          {context.t("STD-Employer-Statement.form.Step")} 3
        </div>
        <div className="progress">
          <div className="progress-bar"></div>
        </div>
        <a
          onClick={() => {
            onStepClick(3);
          }}
          className="bs-wizard-dot"
        ></a>
      </div>
      <div
        className={
          currentStep === 4
            ? "col-3 bs-wizard-step "
            : "col-3 bs-wizard-step disabled"
        }
      >
        <div className="bs-wizard-stepnum">
          {context.t("STD-Employer-Statement.form.Step")} 4
        </div>
        <div className="progress">
          <div className="progress-bar"></div>
        </div>
        <a
          onClick={() => {
            onStepClick(4);
          }}
          className="bs-wizard-dot"
        ></a>
      </div>
    </div>
  );
};
export default Step;
